// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--LcPDk","fadeSlideUp":"fadeSlideUp--RF3hv"};